import React from 'react'
import { useCurrentSociety } from '../../../hooks/useCurrentSociety'
import { RegisterMemberBadgeCardBase } from './RegisterMemberBadgeCardBase'
import { useModal } from '../../../hooks/useModal'
import { PreApprovedModal } from './PreApprovedModal'
import { useAppTranslation } from '../../../hooks/useAppTranslation'
import { ResidentUserType } from '../../../state/stores/units'

interface RegisterMemberPreApprovedCardProps {
  residentUserType: ResidentUserType
}

export const RegisterMemberPreApprovedCard = ({
  residentUserType,
}: RegisterMemberPreApprovedCardProps): React.ReactNode => {
  const { society } = useCurrentSociety()
  const { translate } = useAppTranslation()
  const {
    show: showPreApprovedModal,
    open: openPreApprovedModal,
    close: closePreApprovedModal,
  } = useModal()
  const preApproved = society?.preApprovedList || []

  const filteredPreApproved = preApproved.filter((_preApproved) =>
    residentUserType === ResidentUserType.MEMBER
      ? _preApproved.role === 'member'
      : _preApproved.role !== 'member'
  )

  if (!filteredPreApproved || filteredPreApproved.length === 0) {
    return null
  }

  return (
    <PreApprovedModal
      show={showPreApprovedModal}
      close={closePreApprovedModal}
      preApproved={filteredPreApproved}
    >
      <RegisterMemberBadgeCardBase
        onClick={openPreApprovedModal}
        count={filteredPreApproved.length}
        label={translate('preApproved.title')}
      />
    </PreApprovedModal>
  )
}
